/**
 * Hotel Booking Form JS
 * Card type detection, CC formatting, traveler management, form submission
 */
(function HotelBookingForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'HotelBooking'
	};

	var travelerIndex = 0;

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	function detectCardType(number) {
		var cleaned  = number.replace(/\D/g, ''),
			first    = cleaned.substring(0, 1),
			firstTwo = cleaned.substring(0, 2);

		if (first === '4') { return 'VI'; }
		if (first === '5') { return 'MC'; }
		if (firstTwo === '34' || firstTwo === '37') { return 'AX'; }
		if (first === '6') { return 'DS'; }
		return '';
	}

	function getCardIcon(type) {
		switch (type) {
			case 'VI': return '<i class="fa fa-cc-visa fa-lg text-primary"></i>';
			case 'MC': return '<i class="fa fa-cc-mastercard fa-lg text-danger"></i>';
			case 'AX': return '<i class="fa fa-cc-amex fa-lg text-info"></i>';
			case 'DS': return '<i class="fa fa-cc-discover fa-lg text-warning"></i>';
			default: return '';
		}
	}

	function addTravelerRow(data) {
		var idx  = travelerIndex,
			html = '<div class="hotel-traveler-row well well-sm margin10-bottom" data-index="' + idx + '">'
				+ '<div class="row">'
				+ '<div class="col-sm-4">'
				+ '<div class="form-group">'
				+ '<label class="control-label">First Name</label>'
				+ '<input type="text" class="form-control traveler-first-name" value="' + (data.first_name || '') + '">'
				+ '</div></div>'
				+ '<div class="col-sm-4">'
				+ '<div class="form-group">'
				+ '<label class="control-label">Last Name</label>'
				+ '<input type="text" class="form-control traveler-last-name" value="' + (data.last_name || '') + '">'
				+ '</div></div>'
				+ '<div class="col-sm-3">'
				+ '<div class="form-group">'
				+ '<label class="control-label">Email <small>(optional)</small></label>'
				+ '<input type="text" class="form-control traveler-email" value="' + (data.email || '') + '">'
				+ '</div></div>'
				+ '<div class="col-sm-1">'
				+ '<div class="form-group">'
				+ '<label class="control-label">&nbsp;</label>'
				+ '<button type="button" class="btn btn-danger btn-sm btn-block hotel-remove-traveler" title="Remove"><i class="fa fa-times"></i></button>'
				+ '</div></div>'
				+ '</div></div>';

		travelerIndex++;
		$('.hotel-travelers-container').append(html);
	}

	function serializeTravelers() {
		var travelers = [];

		$('.hotel-traveler-row').each(function eachTraveler() {
			var firstName = $(this).find('.traveler-first-name').val().trim(),
				lastName  = $(this).find('.traveler-last-name').val().trim(),
				email     = $(this).find('.traveler-email').val().trim();

			if (firstName && lastName) {
				travelers.push({
					first_name: firstName,
					last_name : lastName,
					email     : email
				});
			}
		});

		return JSON.stringify(travelers);
	}

	form.load = function load()
	{
		// ─── Card Type Detection ────────────────────────────────────────

		$(document).on('keyup change', '.hotel-cc-number', function detectCard() {
			var val  = $(this).val(),
				type = detectCardType(val);

			$('.hotel-card-type-icon').html(getCardIcon(type));
			$('[name="payment[type]"]').val(type);
		});

		// ─── CC Number Formatting ───────────────────────────────────────

		$(document).on('keyup', '.hotel-cc-number', function formatCard() {
			var val       = $(this).val().replace(/\D/g, ''),
				formatted = '',
				i;

			for (i = 0; i < val.length; i++) {
				if (i > 0 && i % 4 === 0) {
					formatted += ' ';
				}
				formatted += val[i];
			}
			$(this).val(formatted);
		});

		// ─── Expiration Formatting ──────────────────────────────────────

		$(document).on('keyup', '.hotel-cc-expiry', function formatExpiry() {
			var val = $(this).val().replace(/\D/g, '');

			// auto-insert slash after MM
			if (val.length >= 2) {
				val = val.substring(0, 2) + '/' + val.substring(2, 4);
			}

			$(this).val(val);
		});

		// ─── Traveler Management ────────────────────────────────────────

		$(document).on('click', '.hotel-add-traveler', function addTraveler(e) {
			e.preventDefault();
			addTravelerRow({});
		});

		$(document).on('click', '.hotel-remove-traveler', function removeTraveler(e) {
			e.preventDefault();
			$(this).closest('.hotel-traveler-row').remove();
		});

		// ─── Terms checkbox: button disabled until user agrees ────────────

		$('.hotel-submit-booking-btn').prop('disabled', true);

		$(document).on('change', '.hotel-booking-form .hotel-booking-agree-wrap input[type="checkbox"]', function termsCheck() {
			var $btn = $('.hotel-submit-booking-btn');
			$btn.prop('disabled', !$(this).is(':checked'));
		});

		// ─── Submit button spinner ──────────────────────────────────────

		$(document).on('submit', '.hotel-booking-form', function onSubmit() {
			var $btn = $('.hotel-submit-booking-btn');
			$btn.data('hotel-booking-original-html', $btn.html());
			$btn.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Processing...');
		});
	};

	function restoreSubmitButton() {
		var $btn = $('.hotel-submit-booking-btn');
		var originalHtml = $btn.data('hotel-booking-original-html');

		$btn.prop('disabled', false);
		if (originalHtml) {
			$btn.html(originalHtml);
		}
	}

	form.beforeSubmit = function beforeSubmit()
	{
		$('[name="travelers_json"]').val(serializeTravelers());
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			restoreSubmitButton();
			return false;
		}

		if (response.data && response.data.redirect) {
			window.location.href = response.data.redirect;
		} else if (response.redirect) {
			window.location.href = response.redirect;
		}

		return true;
	};

	form.error = function error(err, response)
	{
		restoreSubmitButton();
	};

}(jQuery, window.Adzuki || {}));
